import type { ProjectsListQueryParams } from "./useProjectsListQuery";

export const PROJECTS_QUERY_KEYS = {
  all: ["PROJECTS"] as const,
  list: (params: ProjectsListQueryParams) =>
    [...PROJECTS_QUERY_KEYS.all, "LIST", params] as const,
  detail: (projectId: string) =>
    [...PROJECTS_QUERY_KEYS.all, "DETAIL", projectId] as const,
  jobs: (projectId: string) =>
    [...PROJECTS_QUERY_KEYS.all, "JOBS", projectId] as const,
  jobDetail: (projectId: string, jobId: string) =>
    [...PROJECTS_QUERY_KEYS.all, "JOB_DETAIL", projectId, jobId] as const,
  actorVoices: (projectId: string) =>
    [...PROJECTS_QUERY_KEYS.all, "ACTOR_VOICES", projectId] as const,
  documents: (projectID: string) =>
    [...PROJECTS_QUERY_KEYS.all, "DOCUMENTS", projectID] as const,
} as const;
